import { render, staticRenderFns } from "./NewWebsiteAlt.vue?vue&type=template&id=40552f45&"
import script from "./NewWebsiteAlt.vue?vue&type=script&lang=js&"
export * from "./NewWebsiteAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40552f45')) {
      api.createRecord('40552f45', component.options)
    } else {
      api.reload('40552f45', component.options)
    }
    module.hot.accept("./NewWebsiteAlt.vue?vue&type=template&id=40552f45&", function () {
      api.rerender('40552f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepOne/NewWebsiteAlt.vue"
export default component.exports